import { doodBlockConfig } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export type OrderDetailsPreviewLineItem = {
  line_id: number;
  type: string;
  level: number;
  title: string;
  quantity: number;
  unit_price: number;
  price?: number;
  subtype: string;
  currency: string;
  tax_rate: number;
  price_included: boolean;
  tax_price: number | null;
  price_gross: number | null;
  image: string | null;
  shop_id: string | null;
  product_id: string | null;
  description: string | null;
  delivery_price_amount: number;
};

export type OrderDetailsPreviewShop = {
  id: string;
  name: string;
};

export type OrderDetailsPreviewOrder = {
  id: string;
  number: string;
  status:
    | 'PAYMENT'
    | 'WAITING'
    | 'PREPARATION'
    | 'READY'
    | 'COLLECTED'
    | 'CANCELLED';
  type: 'delivery' | 'click-and-collect' | 'on-site' | 'eat-in';
  ready_at: string | null;
  created_at: string;
  cancellation_reason: string | null;
  multi_shop: boolean;
  onsite_location_id: string | null;
  final_price: number;
  paid_amount: number | null;
  tip: { amount: number } | null;
  coupons: readonly unknown[];
  shop: OrderDetailsPreviewShop | null;
  line_items: readonly OrderDetailsPreviewLineItem[];
};

/**
 * Serializable preview VM for `OrderDetailsBlockComponent`.
 * Kept in content-builder so dashboard + webapp share the same transport shape.
 */
export type OrderDetailsBlockScenarioContent = {
  order: OrderDetailsPreviewOrder | null;
  onSiteLocationName: string;
};

export const ORDERDETAILSBLOCK_LEGACY_FIELD_ORDER = [] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  orderDetailsBlockDescriptor: _generatedOrderDetailsBlockDescriptor,
  orderDetailsBlockBlocDefinition,
  orderDetailsBlockDashboardLayout,
  orderDetailsBlockConfig,
  orderDetailsBlockResolveConfig,
  orderDetailsBlockProperties,
  orderDetailsBlockDefinitionSetupScenarios,
} = doodBlockConfig(
  {
    name: 'Order details',
    componentType: 'OrderDetailsBlockComponent',
    category: 'content',
    description: 'Order details.',
    keywords: [],
    allowedIn: [{ bloc: 'OrderDetailsPageComponent', slot: '*' }],
    sharedFields: {},
  },

  () => ({}),

  () => 'displayAll',
);

export function orderDetailsBlockDescriptor(): IBlockDescriptor;
export function orderDetailsBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function orderDetailsBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedOrderDetailsBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedOrderDetailsBlockDescriptor,
    orderDetailsBlockProperties,
    fieldOrder,
  );
}

export {
  orderDetailsBlockBlocDefinition,
  orderDetailsBlockDashboardLayout,
  orderDetailsBlockProperties,
  orderDetailsBlockConfig,
  orderDetailsBlockResolveConfig,
  orderDetailsBlockDefinitionSetupScenarios,
};

export type OrderDetailsBlockConfig = typeof orderDetailsBlockConfig;
